
import { Member } from '../audience-api';
import { Bot } from '../bot-loaders';
import { Campaign, CampaignMessageResult } from '../campaign-api';
import { createContextProvider } from '../components/store-utils';

export interface MStatus {
    [key:number] : CampaignMessageResult
}


interface CampaignState {
    bot?: Bot
    campaigns?: Campaign[]
    editCampaign?: Campaign
    viewCampaign?: Campaign
    members?: Member[]
    messageStatus?: MStatus
}

type CampaignAction = 
{type: "setBot", bot: Bot} | 
{type: "setCampaigns", list: Campaign[]} |
{type: "setEditCampaign", campaign: Campaign} |
{type: "setViewCampaign", campaign: Campaign}  |
{type: "setMembers", members: Member[]} |
{type: "setMessageStatus", mStatus: MStatus}  

function reducer(state: CampaignState, action: CampaignAction):CampaignState{
    switch(action.type){
        case "setBot": return {...state, bot: action.bot}
        case "setCampaigns": return {...state, campaigns: action.list}
        case "setEditCampaign": return {...state, editCampaign: action.campaign}
        case "setViewCampaign": return {...state, viewCampaign: action.campaign}
        case "setMembers": return {...state, members: action.members}
        case "setMessageStatus": return {...state, messageStatus: action.mStatus}
        default: return state;
    }
}


export const [CampaignContext, CampaignStore] = createContextProvider(reducer, {});